/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Entity } from '../models/Entity';
import type { EntityBasicDetailsDto } from '../models/EntityBasicDetailsDto';
import type { EntityContentDto } from '../models/EntityContentDto';
import type { EntityCreateDto } from '../models/EntityCreateDto';
import type { EntityInvestigationDto } from '../models/EntityInvestigationDto';
import type { HousingFormDefinitionAuditDto } from '../models/HousingFormDefinitionAuditDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EntityService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all entities for this org
     * @param orgGuid
     * @returns EntityBasicDetailsDto OK
     * @throws ApiError
     */
    public getAllEntitiesInOrg(
        orgGuid: string,
    ): CancelablePromise<Array<EntityBasicDetailsDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Entity/{orgGuid}/GetAllEntitiesInOrg',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all entities for this entity definition
     * @param orgGuid
     * @param entityDefinitionGuid
     * @returns Entity OK
     * @throws ApiError
     */
    public getEntities(
        orgGuid: string,
        entityDefinitionGuid: string,
    ): CancelablePromise<Array<Entity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Entity/{orgGuid}/{entityDefinitionGuid}/GetEntities',
            path: {
                'orgGuid': orgGuid,
                'entityDefinitionGuid': entityDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a entity instance by GUID.
     * @param entityGuid The entity GUID.
     * @returns EntityContentDto OK
     * @throws ApiError
     */
    public getEntity(
        entityGuid: string,
    ): CancelablePromise<EntityContentDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Entity/{entityGuid}/GetEntity',
            path: {
                'entityGuid': entityGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a entity instance's basic details by GUID.
     * @param entityDefinitionGuid
     * @param orgGuid
     * @returns EntityBasicDetailsDto OK
     * @throws ApiError
     */
    public getBasicEntityDetails(
        entityDefinitionGuid: string,
        orgGuid?: string,
    ): CancelablePromise<Array<EntityBasicDetailsDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Entity/{entityDefinitionGuid}/GetBasicEntityDetails',
            path: {
                'entityDefinitionGuid': entityDefinitionGuid,
            },
            query: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param orgGuid The guid of the org group.
     * @param requestBody The updated org.
     * @returns Entity OK
     * @throws ApiError
     */
    public updateEntity(
        orgGuid: string,
        requestBody?: Entity,
    ): CancelablePromise<Entity> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Entity/{orgGuid}/UpdateEntity',
            path: {
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new entity
     * @param requestBody The new org.
     * @returns Entity OK
     * @throws ApiError
     */
    public createEntity(
        requestBody?: EntityCreateDto,
    ): CancelablePromise<Entity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/Entity/CreateEntity',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get investigation information for an entity - workflows, org groups, and form responses
     * @param entityGuid The entity GUID.
     * @returns EntityInvestigationDto OK
     * @throws ApiError
     */
    public getEntityInvestigation(
        entityGuid: string,
    ): CancelablePromise<EntityInvestigationDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Entity/{entityGuid}/GetEntityInvestigation',
            path: {
                'entityGuid': entityGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a summary of FormDefinitions that have housing application form responses,
     * grouped by FormDefinition. Shows whether each form is already adopted into a
     * workflow definition, plus counts of linked vs orphaned responses.
     * Used to identify which forms need to be adopted via AdoptFormIntoWorkflow.
     * @param sysOrgGuid
     * @returns HousingFormDefinitionAuditDto OK
     * @throws ApiError
     */
    public getHousingFormResponsesAudit(
        sysOrgGuid: string,
    ): CancelablePromise<Array<HousingFormDefinitionAuditDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Entity/{sysOrgGuid}/GetHousingFormResponsesAudit',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
